import AvalClass from "./AvalClass";
import PaymentType from "./PaymentType";
import * as Paths from "../config/paths";
import request from 'superagent';

class AvalPremium {

    static get modelName() {
        return 'AvalPremium'
    }

    constructor(object){
        Object.assign(this, object, {aval_class: new AvalClass(object.aval_class),
            payment_type: new PaymentType(object.payment_type)})
    }

    /**
     * Deletes the AvalPremium from the server.
     * @returns {Promise<any>}
     */
    deleteAvalPremium(){
        const url = `${Paths.URL_AVAL_PREMIA}/${this.id}`;

        return new Promise((resolve, reject) => {
            request.delete(url)
                .set('Access-Control-Allow-Origin', '*')
                .set('accept', 'application/json')
                .set('Authorization', sessionStorage.getItem('auth_token'))
                .parse(({body}) => body)
                .end((err, res) => {
                    if (err){
                        reject(err);
                    }
                    resolve(res);
                });
        });
    }
}

export default AvalPremium;